/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Modal_TitleInputs */

const en_cad_modal_title = /** @type {(inputs: Cad_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer arranged a new date`)
};

const ja_cad_modal_title = /** @type {(inputs: Cad_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顧客が新しい日付を提案`)
};

const fr_cad_modal_title = /** @type {(inputs: Cad_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle date convenue avec le client`)
};

const de_cad_modal_title = /** @type {(inputs: Cad_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde hat neuen Termin vereinbart`)
};

/**
* | output |
* | --- |
* | "Customer arranged a new date" |
*
* @param {Cad_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_modal_title = /** @type {((inputs?: Cad_Modal_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Modal_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_modal_title(inputs)
	if (locale === "ja") return ja_cad_modal_title(inputs)
	if (locale === "fr") return fr_cad_modal_title(inputs)
	return de_cad_modal_title(inputs)
});